<h1 class="dialog-title">{{ headerKey | translate:{ param: headerParam } }}</h1>
<close-dialog [handleOnClose]="handleOnClose" [dialogRef]="dialogRef" (onClose)="onClose.emit(true)"></close-dialog>
